import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md card-outline">
        <CardHeader>
          <CardTitle className="font-display text-2xl">Recuperar senha</CardTitle>
          <CardDescription>Enviaremos um link de redefinição para seu e-mail</CardDescription>
        </CardHeader>
        <CardContent>
          {done ? (
            <div className="space-y-4">
              <p className="text-sm">Se o e-mail estiver cadastrado, um link de redefinição foi enviado.</p>
              <Link to="/login" className="text-sm text-blue-600 hover:underline" data-testid="back-login-link">
                Voltar para o login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="fe">E-mail</Label>
                <Input id="fe" data-testid="forgot-email-input" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <Button type="submit" className="w-full bg-slate-900 hover:bg-slate-800" data-testid="forgot-submit-btn" disabled={loading}>
                Enviar link
              </Button>
              <Link to="/login" className="block text-sm text-slate-600 text-center hover:underline">Voltar para o login</Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
